import { GetMessageSetVersion, GetMessageSetVersionVariables } from './__generated__/GetMessageSetVersion'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetMessageSetVersion($input: GetMessageSetVersionInputV2!) {
    getMessageSetVersionV2(input: $input) {
      ... on MessageSetVersionErrorV2 {
        type
        error
      }
      ... on MessageSetVersionV2 {
        id
        title
        messageSetId
        messages {
          id
          text
          characters
          createdAt
          tags
          cardSize
        }
      }
    }
  }
`

export const useGetMessageSetVersion = (variables: GetMessageSetVersionVariables, skip: boolean) => {
  return useQuery<GetMessageSetVersion, GetMessageSetVersionVariables>(QUERY, {
    fetchPolicy: 'network-only',
    variables
  })
}
